import {devLog} from "@/services/logger";
import {
    ASSISTANT_PROGRESS_STATUS,
    BATCH_JOB_END,
    BATCH_JOB_START,
    MESSAGE_TYPE_ERROR,
    SOCKET_TYPE_ANSWER,
    SOCKET_TYPE_BATCH_END,
    SOCKET_TYPE_BATCH_ERROR,
    SOCKET_TYPE_BATCH_PROGRESS,
    SOCKET_TYPE_BATCH_START,
    SOCKET_TYPE_CREATE_DRAFT_ANSWER,
    SOCKET_TYPE_ERROR,
    SOCKET_TYPE_NOTIFY,
    SOCKET_TYPE_SINGLE_JOB_PROGRESS,
    SOCKET_TYPE_USER
} from "@/constants";
import {useChatStore} from "@/modules/chat/stores/chatStore";
import {useAppStateStore} from "@/modules/chat/stores/appStore";
import {dispatchUpdateBalance} from "@/modules/chat/services/event";
import {useToastStore} from "@/modules/chat/stores/toast";
import {
    createAssistantMessage,
    createUserMessage,
    formDraftMessage,
    formErrorMessage
} from "@/modules/chat/services/message";

function handleSocketTypeUser(payload) {
    const { id, text, created_at: createdAt, files } = payload;
    const chatStore = useChatStore();

    const userMessage = createUserMessage(id, text, createdAt, files);

    chatStore.addUserMessage(userMessage);
}
function handleSocketTypeCreateDraft(payload, scrollToBottom = true) {
    const { regeneration } = payload;
    const chatStore = useChatStore();

    const draftMessage = formDraftMessage(regeneration);

    chatStore.addDraftMessage(draftMessage, scrollToBottom);
}

function handleSocketTypeAnswer(payload) {
    const { id, text, created_at: createdAt, reason, stat, files, images, uml_images: uml, can_regenerate: canRegenerate, search, regeneration, assistant, music_files: musicFiles, web_search: webSearch } = payload;
    const chatStore = useChatStore();

    const statistic = {};
    if (stat) {
        statistic.total_tokens = stat.total_tokens;
        statistic.prompt_tokens = stat.prompt_tokens;
        statistic.completion_tokens = stat.completion_tokens;
    }
    const assistantMessage = createAssistantMessage(id, text, createdAt, reason, statistic, files, images, uml, canRegenerate, search, assistant, musicFiles, webSearch);

    if (!regeneration?.id) {
        // для изображения и uml
        chatStore.removeDraftMessage();
        chatStore.addAssistantMessage(assistantMessage);
    } else {
        devLog('handleSocketTypeAnswer text');
        // для текстового ответа
        const draftMessage = chatStore.getDraftMessage();
        if (draftMessage) {
            chatStore.replaceDraftMessageByRegenerationId(regeneration.id, assistantMessage);
        } else {
            chatStore.replaceMessage(regeneration.id, assistantMessage);
        }
    }

    const useAppState = useAppStateStore();
    useAppState.stopBlockSending();

    dispatchUpdateBalance();
}

function handleSocketTypeError(result) {
    devLog('Сообщение-ошибка');
    const chatStore = useChatStore();

    const draftMessage = chatStore.getDraftMessage();
    const jobId = result.payload?.job_id;
    const canRegenerate = draftMessage?.can_regenerate || jobId;

    if (draftMessage) {
        const {id} = draftMessage;
        chatStore.replaceMessageType(id, {type: MESSAGE_TYPE_ERROR, text: result.message, job_id: jobId, can_regenerate: canRegenerate});
    } else {
        const message = formErrorMessage(result.message);
        chatStore.addErrorMessage({...message, job_id: jobId, can_regenerate: canRegenerate});
    }

    const useAppState = useAppStateStore();
    useAppState.stopBlockSending();
}

function handleBatchProgress(result) {
    const {type, payload} = result;
    const chatStore = useChatStore();
    const useAppState = useAppStateStore();
    if (type === SOCKET_TYPE_BATCH_START) {
        const {batch_id: batchId, assistant_ids: assistantIds} = payload;

        const batchProgressMessage = chatStore.getBatchProgressMessage(batchId);

        if (!batchProgressMessage) {
            chatStore.addBatchProgressMessage(batchId, assistantIds);
        }
    } else if (type === SOCKET_TYPE_BATCH_PROGRESS) {
        const {batch_id: batchId} = payload;
        // предусмотри что может не быть записи (перезапустил страницу и т.д)
        chatStore.updateBatchProgressMessage(batchId, payload.progress);
    } else if (type === SOCKET_TYPE_BATCH_END) {
        useAppState.stopBlockSending();
    } else {
        const {batch_id: batchId} = payload;
        // batch error
        const draftMessage = chatStore.getDraftMessage();
        const canRegenerate = draftMessage?.can_regenerate || batchId;
        if (draftMessage) {
            const {id} = draftMessage;
            chatStore.replaceMessageType(id, {type: MESSAGE_TYPE_ERROR, text: result.message, batch_job_id: batchId, can_regenerate: canRegenerate});
        } else {
            const message = formErrorMessage(result.message);
            chatStore.addErrorMessage({...message, batch_job_id: batchId, can_regenerate: canRegenerate});
        }

        chatStore.setStatusBatchProgressAssistantError(batchId);
        chatStore.setStatusBatchProgressAssistantCanceled(batchId);

        useAppState.stopBlockSending();
    }
}


function handleSingleJobProgress(payload) {
    const chatStore = useChatStore();

    const {job_id: jobId, progress, waiting_message: waitingMessage} = payload;
    const draftMessage = chatStore.getDraftMessage();
    if (draftMessage) {
        const {id} = draftMessage;
        chatStore.replaceMessage(id, {...draftMessage, job_id: jobId, progress, waiting_message: waitingMessage});
    } else {
        const message = formDraftMessage();
        chatStore.addDraftMessage({...message, job_id: jobId, progress, waiting_message: waitingMessage});
    }
}

function handleBatchJob(result) {
    const {type, payload} = result;
    const chatStore = useChatStore();

    if (type === BATCH_JOB_END) {
        const { id, text, created_at: createdAt, reason, stat, files, images, uml_images: uml, can_regenerate: canRegenerate, search, regeneration, assistant, batch_id: batchId } = payload;

        const statistic = {};
        if (stat) {
            statistic.total_tokens = stat.total_tokens;
            statistic.prompt_tokens = stat.prompt_tokens;
            statistic.completion_tokens = stat.completion_tokens;
        }
        const assistantMessage = createAssistantMessage(id, text, createdAt, reason, statistic, files, images, uml, canRegenerate, search, assistant);

        if (!regeneration?.id) {
            chatStore.removeDraftMessage();
            // не скролить т.к может читать ответ предыдущего ассистента
            chatStore.addAssistantMessage(assistantMessage, false);
        } else {
            chatStore.replaceMessage(regeneration.id, assistantMessage);
        }

        chatStore.setStatusBatchProgressAssistant(batchId, assistant.id, ASSISTANT_PROGRESS_STATUS.DONE);

        dispatchUpdateBalance();
    } else {
        const { batch_id: batchId, assistant_id: assistantId } = payload;
        chatStore.setStatusBatchProgressAssistantNextProgress(batchId, assistantId);
        // создать draft с иконкой
        handleSocketTypeCreateDraft(payload, false);

        chatStore.setStatusBatchProgressAssistant(batchId, assistantId, ASSISTANT_PROGRESS_STATUS.WORKING);
    }
}

export const socketCallbackOnMessage = (result) => {
    devLog('Сообщение в сокет', result);
    const {type, payload} = result;
    if (type === SOCKET_TYPE_NOTIFY) {
        const {message} = result;
        const toastStore = useToastStore();
        toastStore.showSecondary(`${message}`);
    } else if (type === SOCKET_TYPE_ERROR) {
        handleSocketTypeError(result);
    } else if (type === SOCKET_TYPE_USER) {
        handleSocketTypeUser(payload);
    } else if (type === SOCKET_TYPE_CREATE_DRAFT_ANSWER) {
        handleSocketTypeCreateDraft(payload);
    } else if (type === SOCKET_TYPE_ANSWER) {
        handleSocketTypeAnswer(payload);
    } else if (type === SOCKET_TYPE_SINGLE_JOB_PROGRESS) {
        handleSingleJobProgress(payload);
    } else if ([SOCKET_TYPE_BATCH_START, SOCKET_TYPE_BATCH_END, SOCKET_TYPE_BATCH_PROGRESS, SOCKET_TYPE_BATCH_ERROR].includes(type)) {
        handleBatchProgress(result);
    } else if ([BATCH_JOB_END, BATCH_JOB_START].includes(type)) {
        handleBatchJob(result);
    } else {
        console.log(result);
        throw new Error('Unknown socket message type');
    }
};